/**
 * Krypto-Konstanten für die SPKI-Fingerprint-Implementierung.
 *
 * `MIN_TENANT_KEY_MODULUS_BITS` wird aus `../tenant-config-module/wire.constants.ts` re-exportiert,
 * damit das Crypto-Modul keine harte Abhängigkeit zum Wire-Format-Modul hat,
 * gleichzeitig aber Single-Source-of-Truth bleibt.
 *
 * Fingerprint-Größe wurde mit der Einführung des Pin-im-Token (siehe
 * `docs/cancel-token-wire-format.md`) von 64 auf 40 Bit reduziert, um die
 * SMS-URL-Länge zu senken.
 *
 * @see docs/fingerprint-algorithm-spec.md
 * @see docs/cancel-token-wire-format.md
 */

export { MIN_TENANT_KEY_MODULUS_BITS } from '../tenant-config-module/wire.constants.js';

/**
 * Anzahl Bytes des SHA-256-Prefix, die für den Fingerprint herangezogen werden.
 * 5 Bytes (40 Bit) — passt in den Pin-Slot des Cancel-Tokens.
 */
export const SPKI_FINGERPRINT_BYTES = 5 as const;

/**
 * Anzahl Hex-Zeichen des SPKI-Fingerprints.
 * 5 Bytes → 10 Lowercase-Hex-Zeichen.
 */
export const SPKI_FINGERPRINT_LENGTH = 10 as const;
